import React from "react";
import JoinChorus from "../../components/JoinChorus";
import ApplicationForm from "../../components/ApplicationForm";
import ContactForm from "../../components/ApplicationForm";
import AboutHero from "../../components/AboutHero";

const JoinUs = () => {
  return (
    <div className="pt-[4.75rem] lg:pt-[5.25rem] overflow-hidden">
      <JoinChorus />
      <ContactForm />
    </div>
  );
};

export default JoinUs;
